import React from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import "react-responsive-modal/styles.css";
import { Modal as ReactModal } from "react-responsive-modal";
import { ReactComponent as CheckedSVG } from "../assets/svg/notification-checked.svg";
import { ReactComponent as InformationSVG } from "../assets/svg/notification-information.svg";
import { ReactComponent as HelpSVG } from "../assets/svg/help.svg";
import { ReactComponent as ErrorSVG } from "../assets/svg/error.svg";

const types = {
  success: {
    iconSVG: CheckedSVG,
    color: "#33c494",
  },
  information: {
    iconSVG: InformationSVG,
    color: "#2cadd1",
  },
  question: {
    iconSVG: HelpSVG,
    color: "#2cadd1",
  },
  error: {
    iconSVG: ErrorSVG,
    color: "#f44336",
  },
};

const ModalNotification = ({
  title = "",
  description = "",
  type = "",
  isOpen,
  onClose = () => {},
  buttons = null,
  ...rest
}) => {
  return (
    <>
      <GlobalStyles />
      <ReactModal
        center
        closeOnOverlayClick={false}
        open={isOpen}
        showCloseIcon={false}
        onClose={onClose}
        classNames={{
          modal: "customModalModalNotification",
        }}
        {...rest}
      >
        <ModalContainer>
          {type && (
            <IconSVG as={types[type].iconSVG} fill={types[type].color} />
          )}
          {title && <Title>{title}</Title>}
          {description && <Description>{description}</Description>}
          {buttons && <WrapperButtons>{buttons}</WrapperButtons>}
        </ModalContainer>
      </ReactModal>
    </>
  );
};

const IconSVG = styled.div`
  width: 100px;
  height: 100px;
  min-width: 100px;
  min-height: 100px;

  fill: ${(props) => props.fill};
`;

const Title = styled.div`
  font-size: 1.2em;
  font-weight: 600;

  word-break: break-word;
  text-align: center;
`;

const Description = styled.div`
  white-space: pre-wrap;
  word-break: break-word;
  text-align: justify;
`;

const WrapperButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  width: 100%;

  & > * {
    flex: 1 0 0;
    margin: 5px;
  }

  & > *:last-child {
    flex: 2 0 0;
  }

  @media (max-width: 400px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;

  align-items: center;

  ${IconSVG} {
    margin-bottom: 35px;
  }

  ${WrapperButtons} {
    margin-top: 35px;
  }

  ${Title} {
    margin-bottom: 35px;
  }
`;

const GlobalStyles = createGlobalStyle`

    .customModalModalNotification {
      border-radius: 15px;
      border: 1px solid #ccc;
      padding: 25px;
      max-width: 380px;
    }

`;

export default ModalNotification;
